import routerApps from "@/router/route/apps"
import routerEasy from "@/router/route/easy"
import routerLogin from "@/router/route/login.js"
import routerExternal from "@/router/route/external.js"
import routerTest from "@/router/route/test.js"

const routes = [
    ...routerApps,
    ...routerEasy,
    ...routerLogin,
    ...routerExternal,
    ...routerTest,    
]
export {
    routes
};
